import { PassportContextProvider } from 'hooks/usePassport';
import { Helmet } from 'react-helmet';

import IntroScreen from './IntroScreen';

export function ProtectedRoute({
  children,
  requiredProfileCompleted,
  allowSkippedToBookCall
}) {
  return (
    <>
      <Helmet>
        <title>Upscore</title>
        <description></description>
      </Helmet>

      <PassportContextProvider>
        <IntroScreen
          requiredProfileCompleted={requiredProfileCompleted}
          allowSkippedToBookCall={allowSkippedToBookCall}
        >
          {children}
        </IntroScreen>
      </PassportContextProvider>
    </>
  );
}
